import { render, staticRenderFns } from "./FormLoginComponent.vue?vue&type=template&id=52f9e748&scoped=true"
import script from "./FormLoginComponent.vue?vue&type=script&lang=js"
export * from "./FormLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./FormLoginComponent.vue?vue&type=style&index=0&id=52f9e748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9e748",
  null
  
)

export default component.exports